import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer";
import AccountNumberWithBank from "../../../_utils/CommonViewAllCard/CardSubComponent/AccountNumberWithBank";
import CardActionableButton from "../../../_utils/CommonViewAllCard/CardSubComponent/CardActionableButton";
import FormatAmount from "../../../_utils/FormatAmount/FormatAmount";
import TickerAnimation from "../../../_utils/TickerAnimation";

const InternalTransactionGridView = ({
  setLoading,
  setOpenTransHistory,
  data,
  isSidebarOpen,
  isDistributionPopoverOpen,
  isPopoverOpen,
  currentStatus,
  txnHistorytype,
  onClose,
  paginationDivHeight,
  isLabelClicked,
  LabelAccounts,
  handleLabelSelect,
  setlableInput,
  filterRef,
  openTransHistory,
  onCardNavigate,
  txnId,
  flowType
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const services = useSelector((state) => state.refreshToken.services);
  const benealldata = data;

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "hold":
      case "queued":
        return "var(--queued)";
      default:
        return "var(--settled)";
    }
  };
  const shouldBeRedacted = (price) => {
    return (
      price === "xxxx.xx" ||
      isNaN(+price) ||
      price === null ||
      price === undefined
    );
  };

  const getDistriStatusColor = (status) => {
    switch (status) {
      case "awaiting_verification":
      case "awaiting_funds":
      case "distribution_initiated":
      case "created":
      case "distribution_pending":
      case "approved":
        return "var(--queued)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "distribution_complete":
        return "var(--settled)";
      default:
        return "var(--text-primary)";
    }
  };

  return (
    <div
      className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md ${
        isSidebarOpen ? "sidebar-open" : ""
      }`}
     >
      {benealldata?.map((transactions, index) => {
        return (
          <>
            <CardContainer
              filterRef={filterRef}
              hoverHeight={GlobalConfiguration?.internalTxnCardHoverHeight}
              isDisabled={flowType === "labelsSearch" ? transactions?.txn_id === txnId : false}
              context={transactions}
              isSelected={
                Array.isArray(LabelAccounts) &&
                LabelAccounts?.some((item) => item?.id === transactions?.txn_id)
              }
              onClickHandler={() => {
                const redirectUrl = `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${transactions?.txn_id}`;
                const options =
                  transactions?.lifecycle_status === "pending" &&
                  services?.includes("AInternalTxn")
                    ? {
                        state:
                          currentStatus === "require approval"
                            ? "require approval"
                            : transactions?.lifecycle_status,
                      }
                    : {};

                if (txnHistorytype === "internalTxnHistory") {
                 
                  setOpenTransHistory(false);
                  setLoading(true);

                  setTimeout(() => {
                    setLoading(false);
                  }, IntervalConfiguration.intervalExtraLarge);

                  if (isLabelClicked) {
                    handleLabelSelect?.(transactions);
                    setlableInput(false);
                  } else {
                    onClose?.call();
                    if (onCardNavigate) {
                      onCardNavigate(redirectUrl);
                    } else {
                      navigate(
                        redirectUrl,
                        {
                          replace: openTransHistory ? true : false,
                        },
                        {
                          state: {
                            isViewAll:
                              location.pathname ===
                              "/internal_transaction_dashboard/internal_transaction_view_all"
                                ? true
                                : false,
                          },
                        },
                      );
                      if (openTransHistory) {
                        onClose();
                      }
                    }
                  }
                } else if (
                  !isSidebarOpen &&
                  !isPopoverOpen &&
                  !isDistributionPopoverOpen
                ) {
                  if (isLabelClicked) {
                    handleLabelSelect?.(transactions);
                    setlableInput(false);
                  } else {
                    if (onCardNavigate) {      
                      onCardNavigate(redirectUrl);
                    } else {
                      navigate(redirectUrl, {
                        state: {
                          isViewAll:
                            location.pathname ===
                            "/internal_transaction_dashboard/internal_transaction_view_all"
                              ? true
                              : false,
                          options: options,
                        },
                      });
                      onClose?.call();
                    }
                  }
                } else {
                  onClose?.call();
                  if (onCardNavigate) {
                    onCardNavigate(redirectUrl);
                  } else {
                    navigate(redirectUrl, {
                      state: {
                        isViewAll:
                          location.pathname ===
                          "/internal_transaction_dashboard/internal_transaction_view_all"
                            ? true
                            : false,
                      },
                    });
                  }
                }
              }}
             >
              <card-body>
                <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                  <div className="w-full flex justify-between items-center">
                    <p className="text-font-sm flex-1 truncate font-semibold text-settled">
                      {!shouldBeRedacted(transactions?.amount) && "INR"}{" "}
                      <FormatAmount
                        price={Number(
                          String(transactions?.amount)?.replaceAll(",", ""),
                        )}
                      />
                    </p>

                    <div
                      className={`gap-x-gap-sm ml-margin-sm justify-end ${
                        transactions?.confidential_transaction === "Y" ||
                        isLabelClicked
                          ? "flex"
                          : "hidden"
                      }`}
                    >
                      {transactions?.confidential_transaction === "Y" && (
                        <CardActionableButton
                          icon={ICONS?.CONFIDENTIAL_TRANSACTION}
                          title="confidential"
                          isDisabled={false}
                        />
                      )}

                      {isLabelClicked && (
                        <CardActionableButton
                          icon={
                            Array.isArray(LabelAccounts) &&
                            LabelAccounts?.some(
                              (item) => item?.id === transactions?.txn_id,
                            )
                              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                              : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                          }
                          isDisabled={false}
                        />
                      )}
                    </div>
                  </div>

                  <p className="text-font-xs transform-none text-text-secondary">
                    Amount
                  </p>
                </div>
                <AccountNumberWithBank
                  sourceAccNo={transactions?.owner_account_bank_acc_no}
                  destinationAccNo={transactions?.internal_account_bank_acc_no}
                  destinationIfsc={transactions?.internal_account_ifsc_code}
                  sourceIfsc={transactions?.owner_account_ifsc_code}
                />
                <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                  <div className="w-full flex justify-between items-center">
                    <p className="text-font-sm flex-1 truncate font-normal text-text-primary capitalize">
                      <TickerAnimation
                        text={
                          transactions?.created_on
                            ? formatDateViewAll(
                                transactions?.created_on,
                                false,
                                false,
                              )
                            : "Not given"
                        }
                      />
                    </p>
                  </div>

                  <p className="text-font-xs transform-none text-text-secondary">
                    Created on
                  </p>
                </div>
              </card-body>
              <card-hover>
                <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                  <div className="w-full flex justify-between items-center">
                    <p
                      className="text-font-sm flex-1 truncate font-semibold capitalize"
                      style={{
                        color:
                          transactions?.lifecycle_status === "N/A"
                            ? "var(--text-primary)"
                            : getStatusColor(transactions?.lifecycle_status),
                      }}
                    >
                      <TickerAnimation
                        text={
                          currentStatus === "require approval"
                            ? "Require approval"
                            : transactions?.lifecycle_status || "N/A"
                        }
                      />
                    </p>
                  </div>

                  <p className="text-font-xs transform-none text-text-secondary">
                    Approval status
                  </p>
                </div>
                <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                  <div className="w-full flex justify-between items-center">
                    <p
                      className="text-font-sm flex-1 truncate font-semibold"
                      style={{
                        color:
                          transactions?.distribution_lifecycle_status === "N/A"
                            ? "var(--text-primary)"
                            : getDistriStatusColor(
                                transactions?.distribution_lifecycle_status,
                              ),
                      }}
                    >
                      <TickerAnimation
                        text={
                          transactions?.distribution_lifecycle_status ===
                          "created"
                            ? "Distribution created"
                            : transactions?.distribution_lifecycle_status ===
                                "awaiting_funds"
                              ? "Awaiting funds"
                              : transactions?.distribution_lifecycle_status ===
                                  "distribution_initiated"
                                ? "Distribution initiated"
                                : transactions?.distribution_lifecycle_status ===
                                    "abandoned"
                                  ? "Distribution abandoned"
                                  : transactions?.distribution_lifecycle_status ===
                                      "rejected"
                                    ? "Distribution rejected"
                                    : transactions?.distribution_lifecycle_status ===
                                        "failed"
                                      ? "Distribution failed"
                                      : transactions?.distribution_lifecycle_status ===
                                          "distribution_complete"
                                        ? "Distribution complete"
                                        : transactions?.distribution_lifecycle_status ===
                                            "approved"
                                          ? "Distribution approved"
                                          : transactions?.distribution_lifecycle_status ||
                                            "N/A"
                        }
                      />
                    </p>
                  </div>

                  <p className="text-font-xs transform-none text-text-secondary">
                    Distribution status
                  </p>
                </div>

                <div className="flex flex-col px-padding-sm gap-y-gap-xs">
                  <div className="w-full flex justify-between items-center">
                    <p className="text-font-sm flex-1 truncate font-normal text-text-primary">
                      <TickerAnimation
                        text={
                          transactions?.labels?.join(", ") ||
                          "No labels assigned "
                        }
                      />
                    </p>

                    <div className="flex gap-x-gap-sm ml-margin-sm justify-end">
                      <CardActionableButton
                        icon={ICONS?.LABEL}
                        isDisabled={undefined}
                        title={undefined}
                      />
                    </div>
                  </div>
                </div>
              </card-hover>
            </CardContainer>
          </>
        );
      })}
    </div>
  );
};

export default InternalTransactionGridView;
